import {
  Input,
  Flex,
  Textarea,
  Spacer,
  Stack,
  Fieldset
} from "@chakra-ui/react";
import { toaster } from "../ui/toaster";
import { Field } from "../ui/field";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SimpleOutlineButton } from "./Button";
import { useColorModeValue } from "../ui/color-mode";

const ContactForm = () => {
  const secondBg = useColorModeValue("#b8fff7", "#090110");
  const inputBg = useColorModeValue("#f6f6ff", "#251f35");
  const inputBoxShadow = useColorModeValue(
    "rgba(174, 174, 192, 0.4) 3px 3px 6px 0px inset, rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset;",
    "rgba(174, 174, 192, 0.1) 3px 3px 6px 0px inset, rgba(255, 255, 255, 0.1) -3px -3px 6px 1px inset;"
  );
  const focusShadow = useColorModeValue(
    "inset 6px 6px 10px rgba(174, 174, 192, 0.4), inset -6px -6px 10px #fff",
    "inset 6px 6px 10px rgba(174, 174, 192, 0.1), inset -6px -6px 10px #fff"
  );

  const form = useRef();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const formData = new FormData(form.current);

    try {
      const res = await fetch("https://formspree.io/f/xyzwobjl", {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      });

      if (res.ok) {
        navigate("/");
        window.scrollTo({ top: "0", behavior: "auto" });
        const promise = new Promise((resolve) => setTimeout(resolve, 2000));

        toaster.promise(promise, {
          success: {
            title: "Message Sent!",
            description: "We'll get back to you soon",
          },
          error: {
            title: "Sending failed",
            description: "Something went wrong",
          },
          loading: {
            title: "Sending...",
            description: "Please wait",
          },
        });
      } else {
        throw new Error("Formspree request failed");
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      toaster.error("Sending failed. Please try again.");
    }
  };

  return (
    <Flex
      bgColor={secondBg}
      p={{ base: "5", md: "5", lg: "10" }}
      borderRadius="2xl"
      w="full"
      data-aos="flip-right"
    >
      <form ref={form} onSubmit={handleSubmit} style={{ width: "100%" }}>
        <Fieldset.Root>
          <Fieldset.Content>
            <Field id="name" required>
              <Input
                type="text"
                name="from_name"
                fontSize="sm"
                placeholder="Full Name"
                boxShadow={inputBoxShadow}
                borderRadius="xl"
                _focus={{
                  borderColor: "#008080",
                  boxShadow: focusShadow,
                }}
                bgColor={inputBg}
                h="50px"
              />
            </Field>

            <Spacer h="10" />

            <Stack direction={{ base: "column", md: "row" }} gap={4}>
              <Field id="email" required>
                <Input
                  type="email"
                  name="from_email"
                  fontSize="sm"
                  placeholder="Email Address"
                  boxShadow={inputBoxShadow}
                  borderRadius="xl"
                  _focus={{
                    borderColor: "#008080",
                    boxShadow: focusShadow,
                  }}
                  bgColor={inputBg}
                  h="50px"
                />
              </Field>

              <Field id="number" required>
                <Input
                  type="text"
                  name="from_number"
                  fontSize="sm"
                  placeholder="Phone number"
                  boxShadow={inputBoxShadow}
                  borderRadius="xl"
                  _focus={{
                    borderColor: "#008080",
                    boxShadow: focusShadow,
                  }}
                  bgColor={inputBg}
                  h="50px"
                />
              </Field>
            </Stack>

            <Spacer h="10" />

            <Field id="message" required>
              <Textarea
                name="message"
                fontSize="sm"
                placeholder="Message"
                boxShadow={inputBoxShadow}
                borderRadius="xl"
                _focus={{
                  borderColor: "#008080",
                  boxShadow: focusShadow,
                }}
                bgColor={inputBg}
                h="120px"
              />
            </Field>

            <Spacer h="10" />

            <SimpleOutlineButton
              title="Send Message"
              isLoading={isLoading}
              loadingText="Sending"
              type="submit"
            />
          </Fieldset.Content>
        </Fieldset.Root>
      </form>
    </Flex>
  );
};

export default ContactForm;
